import useNavigateTo from "../../../hooks/useNavigateTo";

const AnchorNav = ({ external, url, navigate, children }) =>
    external ? (
        <a href={url} rel='noopener noreferrer'>
            {children}
        </a>
    ) : (
        <a onClick={navigate}>{children}</a>
    );

const FormNavigate = ({ url, children, addonBefore, external = false }) => {
    let navigateTo = useNavigateTo();
    const callback = () => navigateTo(url);

    return addonBefore ? (
        <p className='center'>
            {`${addonBefore} `}
            <span>
                <AnchorNav external={external} url={url} navigate={callback}>
                    {children}
                </AnchorNav>
            </span>
        </p>
    ) : (
        <p className='center'>
            <AnchorNav external={external} url={url} navigate={callback}>
                {children}
            </AnchorNav>
        </p>
    );
};

export default FormNavigate;
